interface VoteTypes {
  [key: string]: number
}

const vote_types: VoteTypes = {
  'not helpful': 1,
  'neutral': 2,
  'helpful': 3
}

const uppercaseFirstLetters = (vote_type: string): string => {
  return vote_type
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
}

function trackHelpfulnessVotedEvent (vote_type: string): void {
  const { inSidedData, mixpanel } = window
  const { category, topic } = inSidedData.content
  const { tags, title, type } = topic

  mixpanel.track('[Community] Helpfulness Voted', {
    '[Community] Vote Type (String)': uppercaseFirstLetters(vote_type),
    '[Community] Vote Type (Numeric)': vote_types[vote_type],
    '[Community] Topic Title': title,
    '[Community] Topic Type': type === 'discussion' ? 'conversation' : type,
    '[Community] Public Tags': tags ? tags.split(',') : [],
    '[Community] Category Title': category.title
  })
}

export default { trackHelpfulnessVotedEvent }
